import { DropdownButtonType, List,ListItem,ListProps, SingleSelectDropdown, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import {classes,cssClass } from '~src/style';
import { OutputFileFormat } from '~src/ts/ServerApi/types/SubscriptionFlow';

const rootClass: string = 'FlowSubscriptionsOutputsDropdown';
const excelImgPath: string = imgPath('File_excel_14px-small.svg');
const fileImgPath: string = imgPath('File_14px-small.svg');

const outputNameCellIcon = cssClass(rootClass, 'outputNameCellIcon', {
  flex: '0 0 auto',
  paddingRight: TabStyles.Spacing.SmallSpace,
});

const outputRowClass = cssClass(rootClass, 'outputRow', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '25px',
});

export interface FlowSubscriptionOutputFileFormatDropdownProps {
  readonly value: OutputFileFormat;
  readonly disabled: boolean;
  readonly onChange: (value: string) => void;
}

function getRow(icon: string, name: string): React.ReactNode {
  return (
    <div className={outputRowClass}>
      <img src={icon} alt={''} className={classes(outputNameCellIcon)}/>
      <span>{name}</span>
    </div>
  );
}

export const FlowSubscriptionOutputFileFormatDropdown: React.FC<FlowSubscriptionOutputFileFormatDropdownProps> = (props: FlowSubscriptionOutputFileFormatDropdownProps) => {
  const listItems: ListItem[] = [
    { value: 'CSV', disabled: props.disabled, content: getRow(fileImgPath, Messages.flowSubscriptionsTextFile())},
    { value: 'EXCEL', disabled: props.disabled, content: getRow(excelImgPath, Messages.flowSubscriptionsExcelFile())},
  ];

  const listProps: ListProps = {items: listItems};

  return (
    <SingleSelectDropdown
      label={''}
      type={DropdownButtonType.Line}
      list={<List {...listProps} />}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      testId={'flow-subscription-output-file-format'}
    >
    </SingleSelectDropdown>
  );
};
